export enum ESignCategory {
  SQUAWK,
  FLIGHTLOG,
  AIRWORTHY,
  CHECKLIST
}
